import React from "react";
import { FaWhatsapp } from "react-icons/fa";

import { companyInfo } from "../../data/siteContent";

export default function WhatsAppButton() {
  const href = `https://wa.me/${companyInfo.whatsappNumber}?text=${encodeURIComponent(
    companyInfo.whatsappMessage
  )}`;

  return (
    <a
      className="whatsapp-float"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Start a WhatsApp conversation with Thamizhi International Ventures"
    >
      <FaWhatsapp aria-hidden="true" />
    </a>
  );
}
